<template>
  <div class="fullwidth">
    <o-table
        class="mb-4"
        :class="{ 'o-table-has-pagination': configData.length }"
        :data="configData"
        hoverable
    >
      <o-table-column
        v-slot="{ row, index }"
        field="name"
        label="env name"
        sortable
      >
        <div v-if="!row.editable">
          {{ row.name }}
        </div>
        <GlInput
          v-model="row.name"
          v-else
          placeholder="Enter Env Name"
          rules="required"
          name="Env Name"
        />
      </o-table-column>
      <o-table-column
        v-slot="props"
        field="url"
        label="url"
        sortable
      >
        <div v-if="!props.row.editable">
          {{ props.row.url }}
        </div>
        <GlInput
          v-model="props.row.url"
          v-else
          placeholder="Enter Server address"
          rules="required"
          name="Server"
        />
      </o-table-column>
      <o-table-column
          v-slot="props"
          field="apiKey"
          label="api key"
          sortable
          rules="required"
      >
        <div v-if="!props.row.editable">
          {{ props.row.apiKey }}
        </div>
        <GlInput
          v-model="props.row.apiKey"
          v-else
          placeholder="Enter Api key"
          name="Api key"
          rules="required"
        />
      </o-table-column>
      <o-table-column
          v-slot="props"
          field=""
          label="Actions"
          sortable
      >
        <gl-icon
            v-tooltip.top="'Delete env'"
            v-if="configData.length > 1"
            class="pointer mr-2"
            :height="24"
            name="delete-action"
            :width="24"
            @click="removeEnv(props.index)"
        />
      </o-table-column>
    </o-table>
    <div class="flex column align-center">
      <div>
        <GlButton
          title="+"
          dark
          class="mb-4"
          @click="addEnv"
        />
      </div>
      <div>
        <GlButton
          :disabled="!canSave"
          title="Save"
          dark
          @click="saveConfig"
        />
      </div>
    </div>
  </div>
</template>

<script>
//Vuex
import { mapMutations, mapState } from "vuex";
// Components
import GlIcon from "@/components/gl-icon.vue";
import GlInput from "@/components/gl-input.vue";
import GlButton from "@/components/gl-button.vue";
import GlCoinSelect from "@/components/gl-coin-select.vue";
import GlPageWrap from "@/components/layout/gl-page-wrap.vue";

export default {
  components: {
    GlIcon,
    GlInput,
    GlButton,
    GlPageWrap,
    GlCoinSelect,
  },
  data() {
    return {
      configData: [
        {
          name: '',
          url: '',
          apiKey: '',
          blockchains: '',
          editable: true
        },
      ],
      activeTab: 'config',
    }
  },
  computed: {
    ...mapState('config', ['configList']),
    canSave() {
      return this.configData.length > 0 && this.configData.every(item => item.name && item.url && item.apiKey)
    },
  },
  mounted() {
    if (localStorage.getItem('config')) {
      this.configData = JSON.parse(localStorage.getItem('config'))
      this.SET_CONFIG(this.configData)
    }
  },
  methods: {
    ...mapMutations('config', ['SET_CONFIG']),
    saveConfig() {
      const localConfig = JSON.parse(JSON.stringify(this.configData))
      localStorage.setItem('config', JSON.stringify(this.configData))
      this.SET_CONFIG(localConfig)

      this.$toasted.global.success({ message: 'Config saved'})
    },
    addEnv() {
      const defEnvModel = {
        name: '',
        url: '',
        apiKey: '',
        blockchains: '',
        editable: true
      }

      this.configData.push(defEnvModel)
    },
    removeEnv(index) {
      this.configData.splice(index, 1)
    },
  },
}
</script>

<style scoped>
.page-title {
  font-size: 18px;
}

.labeling-tabs-wrap {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

.tab {
  font-weight: 600;
  color: var(--dark-grey-6-e);
  cursor: pointer;
  position: relative;
}

.tab-active {
  font-weight: 600;
  color: var(--space-cadet);
  position: relative;
}

.tab-active::after {
  position: absolute;
  content: "";
  display: block;
  width: 100%;
  height: 4px;
  bottom: -14px;
  background-color: var(--reflex-bluet);
  transition: all 0.5s;
}

.tab-counter {
  height: 20px;
  min-width: 20px;
  border-radius: 20px;
  background: var(--scarlet-red);
  color: #fff;
  position: absolute;
  top: -15px;
  right: -15px;
  font-size: 14px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding: 1px 4px;
}

.conflicts-marker__block {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1;
  border-radius: 3px;
  background: var(--pale-pink);
  padding: 10px;
}
</style>
